import { Injectable } from '@angular/core';
import { AuthRolService } from '../../../core/services/auth-rol.service';
import { DragDropAuthService } from '../../drag-drop/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SchedulerAuthService
  extends AuthRolService
  implements DragDropAuthService
{
  rolesWithOutViewers = ['Chief', 'Admin'];
  protected totalPermits = ['Chief', 'Admin'];

  protected allAccessPlus(roles: string[]): string[] {
    return [...roles, ...this.totalPermits];
  }
  protected accessTo(roles: string[]): boolean {
    return this.lookForRolesNeeded(this.allAccessPlus(roles));
  }
  /****
   IMPLEMENTATION OF THE INTERFACE
   ***/
  allowMovementOnSameList(): boolean {
    return this.orderingItems();
  }
  allowMovementOnDifferentList(): boolean {
    return this.allowMovement();
  }
  allowMovement(): boolean {
    return this.lookForRolesNeeded(this.rolesWithOutViewers);
  }

  /***
   END OF IMPLEMENTATION OF THE INTERFACE
   ***/

  /**
   * This method is used to check if the user can start or end a work order
   */
  startEndWorkOrder(): boolean {
    return this.lookForRolesNeeded(this.rolesWithOutViewers);
  }

  /**
   * This method is used to check if the user can order items
   */
  orderingItems(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }

  /**
   * This method is used to check if the user can put a machine on maintenance or take it off
   */
  machineMaintenance(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }

  sendItemToWaitingList(): boolean {
    return true;
  }

  eliminateWorkOrder(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }
  eliminateItem(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }

  editMachineOperators(): boolean {
    return this.lookForRolesNeeded(this.rolesWithOutViewers);
  }

  canGivePriority(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }

  runningItemOff(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }
  runningItemOffMachine(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }

  printWorkOrderLabel(): boolean {
    return !this.lookForRolesNeeded(['Viewer']);
  }

  printQuantityWorkOrderLabel(): boolean {
    return this.lookForRolesNeeded(['Chief', 'Admin']);
  }
}
